// src/components/Logout.js
import React, { useEffect } from 'react';
import { auth } from '../firebase';
import { useNavigate } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import '../style/Logout.css';

const Logout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    auth.signOut().then(() => {
      navigate('/');
    });
  }, [navigate]);

  return (
    <div>
      <Header />
      <div className="logout-container">
        <h2>Logging Out</h2>
        <p>You have been logged out successfully.</p>
      </div>
      <Footer />
    </div>
  );
};

export default Logout;
